export default __webpack_public_path__ + "static/personaje3x2-d6e72dcf8c2fc77d3fb9dcbe9d341ee9.png";